var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-content",attrs:{"id":"content"}},[_c('b-row',[_c('b-col',[_c('h1',{staticClass:"page-header"},[_vm._v("FAQs")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }